import React from 'react';
import { useTranslation } from 'react-i18next';
import SalesMetrics from './SalesMetrics';
import SalesChart from './SalesChart';

const SalesAnalytics: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">{t('sales.analytics')}</h2>
      <SalesMetrics />
      <SalesChart />
    </div>
  );
};

export default SalesAnalytics;